<template>
  <section id="jobs">
    <h2 class="numbered-heading">Where I've Worked</h2>
    <div class="inner">
      <ul
        role="tablist"
        aria-label="Job Tabs"
      >
        <li
          v-for="(company, index) in workHistory"
          :key="company.name"
        >
          <button
            :id="'tab-'+index"
            :class="selectedTab.name === company.name ? 'selected' : null"
            role="tab"
            :aria-selected="selectedTab.name === company.name ? 'true' : 'false'"
            :aria-controls="'panel-'+index"
            :tabindex="selectedTab.name === company.name ? '0' : '-1'"
            @click="setSelectedTab(index,)"
          >
            <span>{{ company.name }}</span>
          </button>
        </li>
        <div
          v-if="false"
          class="jobs-highlighted"></div>
      </ul>
      <div
        id="panel-0"
        role="tabpanel"
        tabindex="0"
        aria-labelledby="tab-0"
        aria-hidden="false"
      >
        <h3>
          <span>{{ selectedTab.role }}</span>
          <span class="company">
            &nbsp;@
            <a
              :href="selectedTab.site"
              class="inline-link"
              target="_blank"
              rel="noopener noreferrer"
              title="Open company website"
            >
              {{ selectedTab.fullName }}
            </a>
          </span>
        </h3>
        <p class="range">{{ selectedTab.duration }}</p>
        <div class="company-responsibility">
          <ul>
            <li
              v-for="highlight in selectedTab.highlights"
              :key="highlight">
              {{ highlight }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WorkExperience',
  data () {
    return {
      selectedTab: {
        name: 'TCS',
        fullName: 'Tata Consultancy',
        site: 'https://www.tcs.com/',
        role: 'IT Analyst',
        duration: 'Jan 2021 - Present',
        highlights: [
          'Leading a team of 15+ members, managing 140+ websites, communicating with client, designing architecture',
          'Work with a variety of different languages, platforms, frameworks, and content management systems such as Vue, Nuxt, JavaScript, ContentFul, Heroku, SSR etc',
          'Write modern, performant, maintainable code for a leadaing Life Science client',
          'Involved with various organizational tasks such as interviewing candidates, budgeting, generating reports and others'
        ]
      },
      workHistory: [
        {
          name: 'TCS',
          fullName: 'Tata Consultancy',
          site: 'https://www.tcs.com/',
          role: 'IT Analyst',
          duration: 'Jan 2021 - Present',
          highlights: [
            'Leading a team of 15+ members, managing 140+ websites, communicating with client, designing architecture',
            'Work with a variety of different languages, platforms, frameworks, and content management systems such as Vue, Nuxt, JavaScript, ContentFul, Heroku, SSR etc',
            'Write modern, performant, maintainable code for a leadaing Life Science client',
            'Involved with various organizational tasks such as interviewing candidates, budgeting, conducting training sessions and others'
          ]
        },
        {
          name: 'Cognizant',
          fullName: 'Cognizant',
          site: 'https://www.cognizant.com/in/en',
          role: 'Programmer Analyst',
          duration: 'Oct 2018 - Dec 2020',
          highlights: [
            'Write modern, performant, maintainable code for a leading retail client and other internal projects',
            'Work with a variety of different languages, frameworks such as Hybris, Hybris UI, JavaScript, TypeScript, Vue, React, Node, AWS, GraphQL',
            'Completly restructure application architechture using modern frameworks and wireframes',
            'Complete restructure and redesign customer support system using modern chat clients and Zendesk'
          ]
        },
        {
          name: 'UIPL',
          fullName: 'Unifed Infotech',
          site: 'https://www.unifiedinfotech.net/',
          role: 'Jr. Web Developer',
          duration: 'Apr 2016 - Oct 2018',
          highlights: [
            'Worked with a leading Poland based crypto currency trading platform  associated with various blockchains and cryptos such as BTC, Ethereum, LTC, DOGE Coin etc',
            'Work with a variety of different languages, platforms, frameworks, and content management systems such as Node JS, PHP, Laravel, MySQL, MongoDB, Blockchain, Redis, and Memcache',
            'Write modern, performant, maintainable code for a diverse array of client and internal projects'
          ]
        },
        {
          name: 'Encoders',
          fullName: 'Encoders Ltd',
          site: 'https://www.encoders.co.in/',
          role: 'Application Developer',
          duration: 'Sep 2015 - Mar 2016',
          highlights: [
            'Work with a variety of different languages, frameworks such as JavaScript, PHP, MySQL, WordPress, JQuery, Bootstrap, HTML5, CSS3',
            'Created Conference/Event Management software and given onsite support for various big clients',
            'Communicate with multi-disciplinary teams of engineers, designers, producers, and clients on a daily basis'
          ]
        }
      ]
    }
  },
  methods: {
    setSelectedTab (index) {
      this.selectedTab = {
        ...this.workHistory[index]
      }
    }
  }
}
</script>

<style scoped>
</style>
